import axios from "axios";
import { setLoading } from "../app/actions";
import _ from "lodash";
import ICustomer from "models/ICustomer";

export const actionTypes = {
  GET_CUSTOMER_COMPANY_INFORMATION: "GET_CUSTOMER_COMPANY_INFORMATION",
  GET_CUSTOMER_COMPANY_INFORMATION_REQUEST:
    "GET_CUSTOMER_COMPANY_INFORMATION_REQUEST",
  GET_CUSTOMER_COMPANY_INFORMATION_SUCCESS:
    "GET_CUSTOMER_COMPANY_INFORMATION_SUCCESS",
  GET_CUSTOMER_COMPANY_INFORMATION_FAILURE:
    "GET_CUSTOMER_COMPANY_INFORMATION_FAILURE",
};

export default class Actions {
  public static getCompanyInformationForCustomer() {
    return async (dispatch, getState) => {
      const currentCustomer = _.get(
        getState(),
        "app.currentCustomer",
        {}
      ) as ICustomer;
      dispatch(request());
      dispatch(setLoading(true));

      const url = `Customers?$select=Number,Name,LegalForm/Description,KvKNumber,OfficeNumber,MailAddress,Addresses/Country,VatNumber,
      VatPostingGroup/Description,GrowersAssociation,BankAccount,BankAccountSwift,NAKTNumber,BKDNumber,EDICode,FytosanitairNumber,
      Certificates/Participation,Certificates/RegistrationNumber,Certificates/CertificationOrganization,
      Exporter,CNBMember,CNBMemberFrom,CNBMemberTill,DigitalCommunication
      &$expand=LegalForm,Certificates,Contacts,VatPostingGroup,Addresses/Country&$filter=Number eq '${currentCustomer.Number}'`;

      try {
        const { data } = await axios.get(url);
        const payload = _.get(data, "value", []);
        dispatch(success(payload));
        dispatch(setLoading(false));
      } catch (error) {
        dispatch(failure(error));
        dispatch(setLoading(false));
      }
    };

    function request() {
      return { type: actionTypes.GET_CUSTOMER_COMPANY_INFORMATION_REQUEST };
    }
    function success(payload) {
      return {
        type: actionTypes.GET_CUSTOMER_COMPANY_INFORMATION_SUCCESS,
        payload,
      };
    }
    function failure(error) {
      return {
        type: actionTypes.GET_CUSTOMER_COMPANY_INFORMATION_FAILURE,
        error,
      };
    }
  }
}
